import client from './client';

export const fetchSubmissions = async () => {
  const res = await client.get('/api/submissions');
  return res.data;
};

export const submitExam = async (formData) => {
  const res = await client.post('/api/submit', formData);
  return res.data;
};

export const logEvent = async (payload) => {
  try {
    await client.post('/api/logs', payload);
  } catch (err) {
    console.error('[LogEvent Failed]', err.message);
  }
};

export const reportViolation = async (payload) => {
  try {
    await client.post('/api/violation', payload);
  } catch (err) {
    console.error('[ViolationReport Failed]', err.message);
  }
};

export const startExamAttempt = async (payload) => {
  const res = await client.post('/api/exam-attempt/start', payload);
  return res.data;
};

export const sendHeartbeat = async (payload) => {
  try {
    const res = await client.post('/api/heartbeat', payload);
    return res.data;
  } catch (err) {
    console.error('[Heartbeat Failed]', err.message);
    return null;
  }
};

export const getExamAttempt = async (examId, studentName) => {
  const res = await client.get(`/api/exam-attempt/${examId}/${studentName}`);
  return res.data;
};

export const abandonExam = async (payload) => {
  try {
    await client.post('/api/abandon-exam', payload);
  } catch (err) {
    console.error('[Abandon Failed]', err.message);
  }
};
